export default __webpack_public_path__ + "static/media/msv-default-banner.7be4231d.png";